module.exports = __webpack_public_path__ + "static/img/苹果 Apple iPadPro 13英寸（M4）.b6ee66ac.png";